<template>
  <li :id="optionId" class="tariff--version-b card" :class="labelClasses()">
    <div class="tariff--version-b__details" :class="[isBadgeActive() ? 'has-badge' : '']">
      <div class="badge" :class="[badgeColor, { 'static': !dynamicBadge }]" v-if="isBadgeActive() && badgeText">{{badgeText}}</div>
      <span class="basis_volume" v-html="processHTML(formatVolume())"></span>
      <div class="bottom--highlights" v-html="processHTML(txtProductHighlights ? txtProductHighlights : defaultTxtProductHighlights)"></div>
      <div class="bottom--more-info">
        <button class="button text" type="button" @click="showMoreInfoModal=true" v-html="lblMoreInfoButton"></button>
        <SimonModal :is-visible="showMoreInfoModal" id="modal" @hide="showMoreInfoModal = false">
          <div v-html="infoModalHighlights ? infoModalHighlights : defaultInfoModalHighlights"></div>
        </SimonModal>
      </div>
    </div>
    <div class="tariff--version-b__price" :class="[hasVisiblePricePromotion || hasStrikePrice || isBadgeActive() ? 'promotion ' + pricePromoColor : priceColor, {'strikePrice': hasCreditPromotion }]">
      <div class="tariff--price" :class="{'strikePrice': hasStrikePrice }">
        <div class="price--group">
          <div class="price--prefix" v-if="showPriceStarts">
            <div class="price--starts" v-if="showPriceStarts">ab</div>
          </div>
          <div class="price">
            <span :class="hasCreditPromotion ? 'price--strikethrough' : 'price--amount'" :aria-hidden="hasCreditPromotion">
              {{ priceWithoutEuro(optionPriceWithBasicFee) }}
            </span>
            <span v-if="hasCreditPromotion" class="price--amount">
              {{ priceWithoutEuro(getCreditPromotionsForOption) }}
            </span>
          </div>
          <div class="price--postfix">
            <span v-html="processHTML(txtPriceCurrency)"></span>
            <button type="button" aria-haspopup="dialog" :aria-label="txtInfoIconAlt" class="icon-only price--info" @click="trackAndShowInfoModal()" style="cursor: pointer;">
              <img src="files/flash/images/svg-icons/info-icon-white.svg" alt="">
            </button>
          </div>
        </div>
      </div>
      <SimonModal :is-visible="showInfoModal" @hide="showInfoModal = false" size="large"
                  :area-label-modal="getSlotText('lblTermsModal', 'Rechtliche Hinweise')">
        <div v-html="processHTML(txtLegalTerms)"></div>
      </SimonModal>
      <div class="bottom--cta">
        <a :id=optionId class="button filled fluid yellow" :href="ctaLink" data-prid="button-checkout" :aria-label="lblAriaLabelCTA" @mousedown="setAboOption()" v-html="lblOrderButton"></a>
      </div>
      <div class="bottom--more-info">
        <button class="button text" type="button" @click="showMoreInfoModal=true" v-html="lblMoreInfoButton" aria-haspopup="dialog" :aria-label="lblMoreInfoButton"></button>
        <SimonModal :is-visible="showMoreInfoModal" id="modal" @hide="showMoreInfoModal = false" :area-label-modal="areaLabelMoreInfo">
          <div v-html="processHTML(infoModalHighlights ? infoModalHighlights : defaultInfoModalHighlights)"></div>
        </SimonModal>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import SimonModal from '@/components/modal/SimonModal.vue'
import useFeature from '@/mixins/useFeature'
import trackingHandler from '@/mixins/trackingHandler'
import priceFormatter from '@/mixins/formatters/price'
import date from '@/mixins/validators/date'

export default {
  name: 'AboOptionVersionB',
  data () {
    return {
      selectedOption: 'none',
      showInfoModal: false,
      showMoreInfoModal: false
    }
  },
  components: {
    SimonModal
  },
  mixins: [
    date,
    trackingHandler,
    useFeature('birthdayPromo')
  ],
  props: {
    optionId: {
      type: String,
      default: null
    },
    targetTariff: {
      type: Object,
      default: null
    },
    availableAboOptions: {
      type: Array,
      default: () => []
    },
    volumePromotions: {
      type: Array,
      default: () => []
    },
    showPriceStarts: {
      type: Boolean,
      default: true
    },
    process: {
      type: String,
      default: 'ordering'
    },
    targetPromotions: {
      type: Array,
      default: () => []
    },
    excludePromotionIds: {
      type: Array,
      default: () => []
    },
    price: {
      type: Number,
      default: 0
    },
    normalPrice: {
      type: Object,
      default: null
    },
    amount: {
      type: Number,
      default: 0
    },
    basisVolume: {
      type: Number,
      default: 0
    },
    showPriceInOption: {
      type: String,
      default: ''
    },
    promoAmount: {
      type: String,
      default: ''
    },
    promoPrice: {
      type: Object,
      default: null
    },
    ctaLink: {
      type: String,
      default: '/bestellung'
    },
    txtProductHighlights: {
      type: String,
      default: ''
    },
    defaultTxtProductHighlights: {
      type: String,
      default: ''
    },
    infoModalHighlights: {
      type: String,
      default: ''
    },
    defaultInfoModalHighlights: {
      type: String,
      default: ''
    },
    lblMoreInfoButton: {
      type: String,
      default: ''
    },
    areaLabelMoreInfo: {
      type: String,
      default: ''
    },
    lblOrderButton: {
      type: String,
      default: ''
    },
    txtLegalTerms: {
      type: String,
      default: ''
    },
    pricePromoColor: {
      type: String,
      default: ''
    },
    priceColor: {
      type: String,
      default: ''
    },
    txtPriceCurrency: {
      type: String,
      default: ''
    },
    showBadge: {
      type: String,
      default: ''
    },
    badgeStart: {
      type: String,
      default: ''
    },
    badgeEnd: {
      type: String,
      default: ''
    },
    badgeText: {
      type: String,
      default: ''
    },
    badgeColor: {
      type: String,
      default: ''
    },
    dynamicBadge: {
      type: String,
      default: ''
    },
    promoVolume: {
      type: Number,
      default: 0
    },
    txtInfoIconAlt: {
      type: String,
      default: ''
    },
    lblAriaLabelCTA: {
      type: String,
      default: ''
    }
  },
  methods: {
    labelClasses () {
      const classes = []

      // needed for promo color
      if (this.promoVolume > 0) {
        classes.push('promotion')
      }
      if (this.cssClass) {
        classes.push(this.cssClass)
      }
      // color handling
      if (this.isBadgeActive()) { // Badge color overwrites usual color or promo color - not anymore...
        classes.push('badge-label')
      }
      if (this.promoVolume > 0) {
        classes.push(this.promoColor)
      } else {
        classes.push(this.color)
      }

      return classes
    },
    setAboOption () {
      const option = this.findTarifOption([this.optionId])
      this.$store.commit('checkoutv2/' + this.process + '/_cart/setSelectedTariffoptionIds', (this.optionId !== 'none' && option[0] !== undefined) ? [option[0]?.tariffoptionId] : [])
    },
    getPromotionsForOption (optionIds) {
      return this.volumePromotions.filter(promo => {
        const promoOptionIds = promo.criteria?.tariffoptionIds || []
        return promoOptionIds.find(id => optionIds.includes(id))
      })
    },
    isBadgeActive () {
      return this.showBadge && this.todayIsBetweenDates(this.badgeStart, this.badgeEnd)
    },
    toDate (string) {
      let datum = null
      if (string && string.length === 10) {
        const parts = string.split('.')
        if (parts.length === 3) {
          datum = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]), 0, 0, 0)
        }
      }
      return datum
    },
    trackAndShowInfoModal () {
      this.showInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'price info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      this.trackData('information', data)
    },
    priceWithoutEuro (price) {
      return priceFormatter.methods.priceWithoutEuro(price)
    },
    formatVolume: function () {
      return this.processHTML(`${this.basisVolume}<span class="unit">GB</span>`)
    }
  },
  computed: {
    ...mapGetters('checkout/tariff', [
      'findTarifOption',
      'defaultTariff'
    ]),
    ...mapGetters('promotion', ['presalesInclusivePromotion']),
    selectedAboOptionId: function () {
      const selectedTariffOptionIds = this.$store.getters['checkoutv2/' + this.process + '/_cart/selectedTariffOptionIds'] // used in propositions
      return selectedTariffOptionIds.length > 0 ? selectedTariffOptionIds[0] : null
    },
    hasVisiblePricePromotion () {
      // gilt für 30GB Promo und 130GB Option
      if (this.birthdayPromo && ['3036138', '3035138'].includes(this.promotionId)) {
        return true
      }
      // kwk promotions enforce no promo layout
      return this.creditPromotions.find(promo => {
        return !this.excludePromotionIds.includes(promo.promotionId)
      })
    },
    creditPromotions () { // only price promotions (permanent and temporary)
      return this.filteredPromotions.filter(promo => promo.incentives?.find(incentive => incentive.type === 'credit'))
    },
    filteredPromotions: function () {
      return this.targetPromotions.filter(promo => {
        // promotions that need e.g. voucher code are not displayed in tariff
        if (promo.requiredParameters !== null) return false

        // Tariff Filter -> only promotions that accept the current targetTariff
        if (this.targetTariff && this.targetTariff.tariffId !== null) {
          const tariffIds = promo.criteria?.tariffIds || []
          if (tariffIds.length > 0 && tariffIds.includes(this.targetTariff.tariffId) === false) return false
        }

        // Provider Filter -> only promotions that dont need a certain provider
        const criteriaMnpProvider = promo.criteria?.mnpProvider || []
        return criteriaMnpProvider.length === 0
      })
    },
    hasCreditPromotion () {
      return this.creditPromotions.length || this.isBirthdayPromotion > 0
    },
    hasStrikePrice () { // strike price uses promo filter, targetPromos does not
      return this.getCreditPromotionsForOption !== this.fakeNormalPriceForBirthdayPromo // this.normalPrice.amount
    },
    fakeNormalPriceForBirthdayPromo () {
      if (this.birthdayPromo && this.optionId === '3036138') {
        return this.getCreditPromotionsForOption + 500
      }
      return this.getCreditPromotionsForOption
    },
    getCreditPromotionsForOption () {
      const creditPromos = this.creditPromotions.reduce((sum, promo) => {
        return sum + (promo.incentives[0]?.discount || 0)
      }, 0)

      return this.targetTariff.basicFee + this.price - creditPromos
    },
    isBirthdayPromotion () {
      // gilt für 30GB Promo und 130GB Option
      return (this.birthdayPromo && ['3036138'].includes(this.optionId))
    },
    optionPriceWithBasicFee () {
      const fakePromo = this.isBirthdayPromotion ? 500 : 0
      return this.targetTariff.basicFee + this.price + fakePromo
    }
  }
}
</script>
